/*/
	CART PAGE FETCH
	Submit cart data via fetch, used only on cart page
/*/

function updateItem(e, qty) {
	e.preventDefault();

	var item = e.target.closest('.cart-item'),
		id = item.getAttribute('data-variant'),
		el = {
			qtyBadge: document.querySelectorAll(".badge-quantity"),
			finalPrice: document.querySelector("#cart-total-final-price"),
			qty: item.querySelector(`.col-quantity input`),
			price: item.querySelector(".col-price .money"),
			priceTotal: item.querySelector(".col-total .money")
		},
		data = {
			'id': id,
			'quantity': qty
		},
		payload = {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'X-Requested-With': 'xmlhttprequest'
			},
			body: JSON.stringify(data)
		}

	fetch('/cart/change.js', payload).then(res => res.json()).then(json => {
		var lineitem = json.items.filter(thisitem => thisitem.id == id)[0] || false;

		// Remove item if it doesn't exist
		if (! lineitem) item.remove();

		// Update Cart Badge Quantity
		el.qtyBadge.forEach(badge => badge.innerHTML = json.item_count);

		// Update Variant Prices
		var varPrice = el.price.innerHTML.replace(/\$/g, '');
		el.priceTotal.innerHTML = (varPrice * lineitem.quantity).toFixed(2);

		// Update Final Checkout Price
		el.finalPrice.innerHTML = '$' + (json.total_price / 100).toFixed(2);
	}).catch(err => console.error(err));
}

export function initCart() {
	// Update Item Quantity
	document.querySelectorAll(".col-quantity input").forEach(input => {
		input.addEventListener('change', e => {
			updateItem(e, e.target.value);
		});
	});

	// Delete Item
	document.querySelectorAll(".delete-button").forEach(btn => {
		btn.addEventListener('click', e => {
			updateItem(e, 0);
		});
	});
}
